<div style="background-color: #fafafa;margin: -20px;" class="d-flex justify-content-between mb-2 pl-3 pt-2">
    <div class="d-flex"><img src="assets/img/profile/group.svg" class="groupFacility mr-2">
        <h3 class="mb-2 mt-1 py-1 font-weight-bold">Site Switcher Sample</h3>
    </div>
    <mat-icon (click)="onCloseDialog()" class="cursor mr-2 mt-1">close</mat-icon>
</div>
<div class="search-container1 mt-4">
    <div class="searchBackground">
        <div class="col-auto">
            <div class="input-group pt-1">
                <input [(ngModel)]="facilityName" style="background: #fff !important;padding-left:14px;" matInput class="form-control search-patient my-0 py-1 mdisplay" type="text" placeholder="{{'Searchsite' | translate}}" aria-label="Search">
                <div class="input-group-append">
                    <span class="input-group-text red lighten-3 " id="basic-text1">
                      <mat-icon *ngIf="!facilityName">search</mat-icon>
                      <mat-icon *ngIf="facilityName" (click)="removeSearchText()"
                          style="cursor: pointer">close
                      </mat-icon>
                  </span>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid assetvideo">
        <div class="row site-div-hover" *ngFor="let facility of facilityData | filter:facilityName; let i = index;">
            <div class="col-12 p-0 mt-2 border-bottom pb-2">
                <div class="d-flex">
                    <div class="site-assets-container d-flex justify-content-center">
                        <img src="assets/img/profile/facility-site.svg" class="imagesize">
                    </div>
                    <div class="ml-2 videotext">
                        <div class="name-ellipsis">{{facility.facilityName}}</div>
                        <div class="normalText">
                            <span>SAP Account Id #{{facility.facilitySAPId}}</span>
                        </div>
                    </div>
                    <div class="w-100 cursor text-right d-flex align-items-center d-flex justify-content-end" (click)="redirectSelectedfacility(facility.facilityName)">
                        <button mat-raised-button type="submit" color="primary" class="card-header-action set-button mr-3">Set</button>
                    </div>
                </div>
            </div>
        </div>
        <span *ngIf="(facilityData !== null && (facilityData | filter: facilityName).length === 0 && facilityName !== null && facilityName !== '')">
          {{'Nomatches'|translate}}</span>
    </div>
</div>